import { type FC } from 'react';
import CakeOrdersTab from '../components/Cakes/CakeOrdersTab';

const CakeCollections: FC = () => {
    return (
        <div className="space-y-6">
            <div className="flex items-center gap-3">
                <div>
                    <h1 className="text-2xl font-semibold text-stone-900">Cake Collections</h1>
                    <p className="mt-0.5 text-sm text-stone-500">Manage cake orders awaiting in-store collection</p>
                </div>
            </div>

            <CakeOrdersTab />
        </div>
    );
};

export default CakeCollections;